import { render, staticRenderFns } from "./AIAssistanceButton.vue?vue&type=template&id=dc7bd7ba&scoped=true&"
import script from "./AIAssistanceButton.vue?vue&type=script&lang=js&"
export * from "./AIAssistanceButton.vue?vue&type=script&lang=js&"
import style0 from "./AIAssistanceButton.vue?vue&type=style&index=0&id=dc7bd7ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7bd7ba",
  null
  
)

export default component.exports